<script setup lang="ts">
import { useBrowserStore } from '@apps/main/new-desktop/core/stores';

import { AppButton, SemboBaggage } from '@libs/ui';

interface HotelSelectionNoResultsProps {
  hasActiveHotelFilters: boolean;
}

const props = defineProps<HotelSelectionNoResultsProps>();

interface HotelSelectionNoResultsEmits {
  (eventName: 'reset-filters'): void;
}

const emit = defineEmits<HotelSelectionNoResultsEmits>();

const browserStore = useBrowserStore();
</script>

<template>
  <div class="hotel-selection-no-results">
    <SemboBaggage />
    <div class="title">{{ $t('no_results_banner.sorry_no_results') }}</div>
    <div class="content">
      <p>{{ $t('no_results_banner.try_the_following') }}</p>
      <ul>
        <li v-if="props.hasActiveHotelFilters">
          {{ $t('no_results_banner.change_your_filters') }}
        </li>
        <li v-if="browserStore.isLargerThan1199px">
          {{ $t('no_results_banner.zoom_out_on_the_map') }}
        </li>
        <li>
          {{ $t('no_results_banner.search_for_different_location') }}
        </li>
      </ul>
    </div>
    <AppButton
      v-if="props.hasActiveHotelFilters"
      type="primary"
      state="enabled"
      size="medium"
      @click="emit('reset-filters')"
    >
      {{ $t('planner.reset_hotel_filters') }}
    </AppButton>
  </div>
</template>

<style scoped lang="scss">
.hotel-selection-no-results {
  background-color: var(--color-white);
  padding: var(--spacing-16);
  margin: 0 var(--spacing-16) var(--spacing-16) var(--spacing-16);
  border: 1px solid var(--color-neutral-30);
  border-radius: var(--border-radius-8);
  height: 100%;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  .title {
    @include font-heading-5;
    margin-bottom: var(--spacing-16);
    margin-top: var(--spacing-8);
  }

  .content {
    @include font-label-m-light;
    margin-bottom: var(--spacing-16);
  }

  @include for-more-or-equal-than-1200-px {
    margin: var(--spacing-24) 0;
  }

  @include for-more-or-equal-than-1535-px {
    margin-top: 0;
  }
}
</style>
